import classNames from 'classnames';
import React from 'react';
import Slot from './Slot';
import * as styles from './SVGIcon.module.scss';

export type SVGIconSize = 'small' | 'regular' | 'large' | number;

interface SVGIconProps
  extends Omit<
    React.HTMLAttributes<HTMLDivElement>,
    'dangerouslySetInnerHTML'
  > {
  children?: string | null;
  inline?: boolean;
  size?: SVGIconSize;
}

const SVGIcon = React.forwardRef<HTMLDivElement, SVGIconProps>(
  ({ children = null, inline = false, size = 'regular', ...props }, ref) =>
    children ? (
      <Slot {...props}>
        <div
          ref={ref}
          className={classNames(styles.icon, {
            [styles.inline]: inline,
            [styles.large]: size === 'large',
            [styles.small]: size === 'small',
          })}
          dangerouslySetInnerHTML={{ __html: children }}
          style={typeof size === 'number' ? { fontSize: size } : undefined}
        />
      </Slot>
    ) : null,
);

SVGIcon.displayName = 'SVGIcon';

export default SVGIcon;
